<template>
	<div
		role="status"
		aria-live="polite"
		aria-atomic="false"
		class="
			fixed inset-x-0 top-20 z-10001! mx-auto w-fit min-w-[400px]
			max-md:inset-x-3 max-md:mx-0 max-md:w-auto max-md:min-w-0
		"
	>
		<!-- The live region is always rendered, so each toast is announced, and so is one updated in place. -->
		<Notification
			v-for="notification in notifications"
			:key="notification.id"
			:notification="notification"
		/>
	</div>
</template>

<script setup>
import Notification from './custom-notification.vue';

defineProps({
	notifications: {
		type: Array,
		default() {
			return [];
		}
	}
});
</script>
